"use client"

import { chakra } from "@chakra-ui/react"
import recipe from "./recipe"

export const SkeletonCircle = chakra("div", recipe);
export default SkeletonCircle
